import React from 'react';
import ServerForm from '../../components/server/ServerForm';

const ServerFormPage = () => {
  return (
    <div>
      <ServerForm />
    </div>
  );
};

export default ServerFormPage;